export const PaymentResultType = {
  SUCCESS: "success",
  PROCESSING: "processing",
  ERROR: "error",
};
